import React, { useState } from 'react';
import TradingViewWidget from '../components/Charts/TradingViewWidget';
import DashboardLayout from '../components/DashboardLayout';
import StockSearchInput from '../components/StockSearchInput';

const ChartV3Page = () => {
    const [symbol, setSymbol] = useState('RELIANCE');

    const handleSymbolSelect = (stock) => {
        const newSymbol = typeof stock === 'string' ? stock : stock.tradingSymbol;
        setSymbol(newSymbol);
    };

    return (
        <DashboardLayout>
            <div className="p-6 h-[calc(100vh-6rem)] flex flex-col">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-base-content">Market Analysis V3 (TradingView Widget)</h1>
                </div>

                {/* Controls - Just symbol search as TV handles interval/dates */}
                <div className="bg-base-200 p-4 rounded-lg flex gap-4 items-center mb-4">
                    <div className="w-64">
                        <StockSearchInput onSelect={handleSymbolSelect} initialValue={symbol} />
                    </div>
                    <div className="badge badge-info gap-2">
                        External Data (TradingView)
                    </div>
                </div>

                <div className="flex-grow bg-base-100 rounded-lg shadow-lg overflow-hidden border border-base-300 relative">
                    <TradingViewWidget symbol={symbol} />
                </div>
            </div>
        </DashboardLayout>
    );
};

export default ChartV3Page;
